import React, { ReactElement, ReactNode } from 'react'

export type FormRowProps = {
    isInline?: boolean
    children: ReactNode
    className?: string
}

/**
 *
 * @param isInline children are inline
 * @param children
 *
 */
const FormRow: React.FC<FormRowProps> = ({ isInline, children, className }: FormRowProps): ReactElement => {
    const classes = `form-row ${isInline ? 'inline' : ''} ${className || ''}`

    return <div className={classes}>{children}</div>
}
export default FormRow
